import React, { useState } from 'react';
import { Popup } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { NumberBox } from 'devextreme-react/number-box';
import { SelectBox } from 'devextreme-react/select-box';
import { TextBox } from 'devextreme-react/text-box';

const Replicate = ({ visible, onClose, onOk }) => {
    const [replicationCount, setReplicationCount] = useState(1);
    const [locateFirst, setLocateFirst] = useState('Y');
    const [shipperBol, setShipperBol] = useState('');

    const handleOk = () => {
        if (onOk) {
            onOk({ replicationCount, locateFirst, shipperBol });
        }
    };

    const handleCancel = () => {
        setReplicationCount(1);
        setLocateFirst('Y');
        setShipperBol('');
        onClose();
    };

    return (
        <Popup
            visible={visible}
            onHiding={handleCancel}
            dragEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            title="WM Replicate Parameters"
            width={300}
            height={250}
        >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <div style={{ flex: 1, padding: '10px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ width: '100px', fontWeight: 'bold', fontSize: '13px' }}>Replication #</label>
                        <NumberBox
                            value={replicationCount}
                            min={1}
                            showSpinButtons={true}
                            stylingMode="outlined"
                            width={120}
                            onValueChanged={(e) => setReplicationCount(e.value)}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ width: '100px', fontWeight: 'bold', fontSize: '13px' }}>Locate First</label>
                        <SelectBox
                            value={locateFirst}
                            dataSource={[{ id: 'Y', name: 'Yes' }, { id: 'N', name: 'No' }]}
                            valueExpr="id"
                            displayExpr="name"
                            stylingMode="outlined"
                            width={120}
                            onValueChanged={(e) => setLocateFirst(e.value)}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <label style={{ width: '100px', fontWeight: 'bold', fontSize: '13px' }}>Shipper BOL#</label>
                        <TextBox
                            value={shipperBol}
                            stylingMode="outlined"
                            width={120}
                            onValueChanged={(e) => setShipperBol(e.value)}
                        />
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', padding: '10px', borderTop: '1px solid #eee' }}>
                    <Button text="OK" type="default" icon="check" onClick={handleOk} />
                    <Button text="Cancel" type="normal" icon="close" onClick={handleCancel} />
                </div>
            </div>
        </Popup>
    );
};

export default Replicate;
